// src/routes/AdminRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

export default function AdminRoute({ children, allowedRoles = [] }) {
  const user = JSON.parse(localStorage.getItem('user'));

  // Not logged in
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Always allow superadmin access
  if (user.role === 'superadmin') {
    return children;
  }

  // Otherwise, check allowed roles
  const hasAccess = allowedRoles.includes(user.role);
  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}
